import { FILTER_OPTIONS } from '@/constants/initiative'
import { snakeCaseToCamelCaseString } from '@/utils/stringCase'
import * as R from 'ramda'

const formatParam = param => {
  if (param === 'priority') {
    param = 'impact'
  } else {
    param = snakeCaseToCamelCaseString(param)
  }
  return param
}

/**
 * This function filters the passed items based on the filter params (filteredBy) passed
 * format of filteredBy can be as below:
 * {
 *   status: {
 *     'on-track': 0
 *     'at-risk': 0
 *   },
 *   priority: {
 *     'low': 0,
 *     'high': 1,
 *   },
 * }
 * 0 means that filter is unselected, 1 means it is selected
 * @param filteredBy - object
 * @param items - array of items
 * @returns {*}
 */
export default ({ filteredBy, items }) => {
  let filterParamsList = []
  R.toPairs(filteredBy).map(([filterParam, filterValues]) => {
    const excludedValues = Object.keys(R.pickBy(val => val === 0, filterValues))
    excludedValues.forEach(filterValue => {
      if (filterValue === 'blank' || excludedValues.length < FILTER_OPTIONS[filterParam].length) {
        // if all filters are unchecked, it means none of the filter should be applied
        filterParamsList.push([filterParam, filterValue])
      }
    })
  })
  return filterParamsList.reduce((items, [filterParam, filterValue]) => {
    const param = formatParam(filterParam)
    if (filterValue === 'blank') {
      return items.filter(item => item[param])
    } else {
      return items.filter(item => item[param] !== filterValue)
    }
  }, items)
}
